import React, { useState } from "react";
import { FaArrowLeft, FaEnvelope } from "react-icons/fa";
import { IoSend } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/Loader/Loader";
import UserService from "../../../services/UserService";
import "./FormEmailResetPassword.css";

function FormEmailResetPassword({ onBack }) {
	const [email, setEmail] = useState("");
	const [showLoader, setShowLoader] = useState(false);
	const navigate = useNavigate();

	// Perfil chamada ao enviar o formulário
	async function handleSubmit(event) {
		event.preventDefault();
		setShowLoader(true);
		await UserService.sendEmailResetPassword(email);
		setShowLoader(false);
		navigate("../login");
	}

	return (
		<div className="email-reset-container paper-background">
			{/* Cabeçalho com botão de voltar e título */}
			<div className="email-reset-header">
				<button className="email-reset-back-icon" onClick={onBack}>
					<FaArrowLeft size={20} />
				</button>
				<h2>Redefinição de Senha</h2>
			</div>
			<p className="email-reset-desc">
				Informe o email cadastrado para receber as instruções de redefinição de
				senha.
			</p>

			<form onSubmit={handleSubmit} className="email-reset-input-container">
				<FaEnvelope className="email-reset-icon" />
				<input
					className="email-reset-input"
					placeholder="Digite seu email"
					type="email"
					value={email}
					onChange={(e) => setEmail(e.target.value)}
					required
				/>
				{showLoader ? (
					<div className="loader">
						<Loader
							styles={{
								marginTop: "0",
							}}
							width={25}
							height={25}
						/>
					</div>
				) : (
					<button type="submit" className="email-reset-send-button">
						<IoSend />
					</button>
				)}
			</form>
		</div>
	);
}

export default FormEmailResetPassword;
